module.exports = __webpack_public_path__ + "img/5.357ba46a.png";